// state
const state = () => ({
    forceBeneficiosST: 0,
    forceBeneficios: 0,
});
  
// getters
const getters = {
    getForceBeneficiosST: (state) => {
      return state.forceBeneficiosST
    },
    getForceBeneficios: (state) => {
      return state.forceBeneficios
    }
};
  
// mutations
const mutations = {
    SET_FORCE_BENEFICIOS_ST (state, forceBeneficiosST) {
      state.forceBeneficiosST = forceBeneficiosST
    },
    SET_FORCE_BENEFICIOS (state, forceBeneficios) {
      state.forceBeneficios = forceBeneficios
    }
}
  
// actions
const actions = {
    setForceBeneficiosST ({ commit, state }) {
        let forceBeneficiosST = state.forceBeneficiosST + 1

        commit('SET_FORCE_BENEFICIOS_ST', forceBeneficiosST)
    },
    setForceBeneficios ({ commit, state }) {
        let forceBeneficios = state.forceBeneficios + 1

        commit('SET_FORCE_BENEFICIOS', forceBeneficios)
    },
}
  
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
